import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getConfigGroupSchema(id: $id) {
        id
        name
    }
}`)
